<template>
  <section class="c-missioncontainer">
    <div class="container">
      <div class="c-missioncontainer__header">
        <h1 class="c-missioncontainer__title">
          {{ $t("Missioni e giochi in continua evoluzione") }}
        </h1>
        <h2 class="c-missioncontainer__subtitle">
          {{
            $t(
              "Queste sono solo alcune delle azioni che i tuoi utenti potranno compiere"
            )
          }}
        </h2>
      </div>
      <div class="c-missioncontainer__content">
        <!-- <template v-for = "(mission, index) in actions">
                <Mission v-bind:key = "index" :title = "mission.title" :points = "mission.points" :type = "mission.type"></Mission>
            </template> -->
        <Mission
          :title="
            $t(
              'Profila e conosci i tuoi fan grazie a domande sulle loro generalità e sulle loro abitudini'
            )
          "
          :points="'25'"
          :type="$t('Domande')"
          :icon="'static/tempAssets/icon-question.svg'"
        ></Mission>
        <Mission
          :title="$t('Coinvolgi i tuoi utenti con giochi di abilità e quiz')"
          :points="'10'"
          :type="$t('Giochi')"
          :icon="'static/tempAssets/icon-game.svg'"
        ></Mission>
        <Mission
          :title="$t('Aumenta la fanbase premiando i tuoi ambassador')"
          :points="'20'"
          :type="$t('Member Get Member')"
          :icon="'static/tempAssets/icon-mgm.svg'"
        ></Mission>
      </div>
      <div class="c-missioncontainer__register__container">
        <div class="c-missioncontainer__register__text__wrapper">
          <h1 class="c-missioncontainer__register__text">
            {{ $t("Entra e scopri subito il mondo di Fanize") }}
          </h1>
        </div>
        <div class="c-missioncontainer__register__button">
          <button class="btn register-button" @click="scrollToTop()">
            {{ $t("Registrati / Accedi") }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Mission from "./Mission";
export default {
  props: ["actions"],
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
  components: {
    Mission
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/mixins";

.c-missioncontainer {
  padding-top: 3rem;
}

.c-missioncontainer__header {
  display: flex;
  flex-direction: column;
  text-align: center;
  color: white;
  @include xl {
    text-align: left;
    max-width: 49%;
  }

  h1 {
    font-size: 32px;
    @include lg {
      font-size: 45px;
    }
  }

  h2 {
    font-size: 28px;
    color: rgba(255, 255, 255, 0.65);
    @include lg {
      font-size: 30px;
    }
  }
}

.c-missioncontainer__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
  @include lg {
    flex-direction: row;
    justify-content: space-between;
  }
}
.c-missioncontainer__register__container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 4rem 0;
  @include lg {
    text-align: left;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}
.c-missioncontainer__register__text__wrapper {
  display: flex;
  flex-direction: column;
}
.c-missioncontainer__register__text {
  color: white;
  @include lg {
    max-width: 60%;
  }
}
.c-missioncontainer__register__subtext {
  color: white;
  color: rgba(255, 255, 255, 0.65);
  @include lg {
    max-width: 100%;
  }
  a {
    color: rgba(255, 255, 255, 0.65);
  }
}
.c-missioncontainer__register__button {
  margin: 2rem 0;
  @include lg {
    max-width: 40%;
  }
}
.btn.register-button {
  border: 2px solid white;
  background-color: white;
  color: #6221e6;
  border-radius: 45px;
  padding: 18px 58px 18px 58px;
  cursor: pointer;
}
.btn.register-button:hover {
  border: 2px solid #6221e6;
  background-color: #6221e6;
  color: white;
}
</style>
